export default "__VITE_ASSET__C581HOtu__"